/**
 * 上新气泡
 * https://onedesign.woa.com/html/adq-specs-popover.html
 */
import React, { CSSProperties, ReactNode, useState, useImperativeHandle, forwardRef } from 'react';
import { Flex, Titlebar } from '@tencent/odc';
import {
  OverlayTrigger,
  PopOver,
  Button,
  OverlayTriggerProps,
  PopOverProps,
} from '@tencent/spaui';
import AdqIcon from '@tencent/adq-icons';

interface IGuidePopoverProps {
  children?: ReactNode;
  trigger?: ReactNode;
  title?: string;
  content?: ReactNode;
  cancelButton?: boolean;
  cancleLabel?: string;
  submitLabel?: string;
  placement?: OverlayTriggerProps['placement'];
  maxWidth?: PopOverProps['maxWidth'];
  width?: CSSProperties['width'];
  closable?: boolean;
}

interface IGuidePopoverRef {
  show: () => void;
  hide: () => void;
}

const GuidePopover = forwardRef<IGuidePopoverRef, IGuidePopoverProps>(({
  trigger,
  children,
  title,
  content,
  cancelButton = false,
  cancleLabel,
  submitLabel,
  placement = 'top',
  maxWidth = 332,
  width,
  closable,
}, ref) => {
  const [visible, setVisible] = useState(false);

  const show = () => {
    setVisible(true);
  };
  const hide = () => {
    setVisible(false);
  };
  useImperativeHandle(
    ref,
    () => ({
      show,
      hide,
    }),
    [],
  );

  const styleObj = { width };

  return (
    <OverlayTrigger
      show={visible}
      placement={placement}
      overlay={
        <PopOver
          maxWidth={maxWidth}
          className="l-guide-pop-v3 z-1000"
          style={styleObj}
        >
          <Flex column gap={12}>
            <Flex itemsCenter justifyContent="between">
              <img
                src="https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1723187651151.svg?max_age=31536000"
                width={40}
                height={18}
                alt=""
              />
              {closable ? (
                <AdqIcon
                  name="cancel"
                  className="text-coolgray-07 hover:text-coolgray-12 cursor-pointer transition-all"
                  onClick={hide}
                />
              ) : null}
            </Flex>
            <Flex column gap={6}>
              <Titlebar size="5" title={title} />
              {content}
            </Flex>
            <Flex itemsCenter justifyContent="end" gap={8}>
              {cancelButton ? <Button
                shape="round"
                displayType="link"
                className="meta-link-btn px-12"
                size="small"
                onClick={(e: Event) => {
                  hide();
                  e.stopPropagation();
                }}
              >
                {cancleLabel || '取消'}
              </Button> : null}
              <Button
                shape="round"
                className="font-600 px-12"
                displayType="primary"
                size="small"
                onClick={(e: Event) => {
                  hide();
                  e.stopPropagation();
                }}
              >
                {submitLabel || '我知道了'}
              </Button>
            </Flex>
          </Flex>
        </PopOver>
      }
    >
      {trigger || children}
    </OverlayTrigger>
  );
});


export default GuidePopover;
